import CircularProgress from '@mui/material/CircularProgress';
import { useEffect } from 'react';
import styled from "styled-components"

export default function ProgressView() {

  useEffect(() => {
    document.body.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <ProgressViewDiv>
      <CircularProgress />
    </ProgressViewDiv>
  )
}

const ProgressViewDiv = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  inset: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 9999;
`